export default class LinkInterceptCallback {
  #id;
  #hrefs = [];
  #callback;
  #linkInterceptor;

  get id() {
    return this.#id;
  }

  get callback() {
    return this.#callback;
  }

  get hrefs() {
    return this.#hrefs;
  }

  constructor(linkInterceptor) {
    this.#linkInterceptor = linkInterceptor;
  }

  create(id, callback, ...hrefs) {
    this.#id = id;
    this.#callback = callback;
    this.#hrefs = hrefs;
  }

  enable() {
    this.#linkInterceptor.rebindEvents();
    this.#linkInterceptor.onIntercept(this.#id, this.#callback, ...this.#hrefs);
  }

  disable() {
    this.#linkInterceptor.removeInterceptCallback(this.#id, ...this.#hrefs);
  }
}